<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-time-picker
      code="duree-formation"
      v-model="sasReconnaissanceDeFormation.dureeFormation"
      :live="liveSasReconnaissanceFormation(10744)"
      :maxHour="999"
      :minutesInterval="15"
      :condition="(v) => !!v && v.split(':').some((n) => parseInt(n) > 0)"
      conditionMessage="La durée doit être supérieure à 0h00."
    ></opq-time-picker>

    <opq-catalogue
      :opq-if="estPsychotherapie"
      code="sujets-formation-PT"
      v-model="sasReconnaissanceDeFormation.sujetsAbordesPsychotherapie"
      :live="liveSasReconnaissanceFormation(10709)"
      multiple
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estPsychologieHorsPT"
      code="sujets-formation-PS"
      v-model="sasReconnaissanceDeFormation.sujetsAbordesPsychologieHP"
      :live="liveSasReconnaissanceFormation(10710)"
      multiple
    ></opq-catalogue>

    <opq-catalogue
      code="modeles-theoriques"
      v-model="sasReconnaissanceDeFormation.modelesTheoriques"
      :live="liveSasReconnaissanceFormation(10711)"
      multiple
      optional
    ></opq-catalogue>

    <opq-catalogue
      code="types-sources"
      v-model="sasReconnaissanceDeFormation.typesDeSources"
      :live="liveSasReconnaissanceFormation(10712)"
      multiple
    ></opq-catalogue>

    <opq-text-field
      :opq-if="estTypeSourceAutre"
      code="autres-types-sources"
      v-model="sasReconnaissanceDeFormation.autreTypeDeSources"
      :live="liveSasReconnaissanceFormation(10713)"
    ></opq-text-field>

    <opq-file
      :opq-if="estFormation || (estEvenement && nEstPasComiteScientifique)"
      code="descriptif"
      :file="sasReconnaissanceDeFormation.descriptif"
      :live="liveSasReconnaissanceFormation(10714)"
    ></opq-file>

    <opq-file-multiple
      :opq-if="estEvenement && estComiteScientifique"
      code="description-ateliers"
      :files="sasReconnaissanceDeFormation.descriptionAteliers"
      :live="liveSasReconnaissanceFormation(10715)"
    >
    </opq-file-multiple>

    <opq-case
      code="attestation-contenu-reconnu"
      v-model="sasReconnaissanceDeFormation.attestationContenuReconnu"
      :live="liveSasReconnaissanceFormation(10716)"
    >
    </opq-case>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasReconnaissanceDeFormation() {
      return this.sas.sasReconnaissanceDeFormation
    },

    estPsychotherapie() {
      return this.getCatalogueCodeById(9810, this.sasReconnaissanceDeFormation.categorieDActivite) == "1"
    },

    estPsychologieHorsPT() {
      return this.getCatalogueCodeById(9810, this.sasReconnaissanceDeFormation.categorieDActivite) == "2"
    },

    estTypeSourceAutre() {
      if (this.sasReconnaissanceDeFormation.typesDeSources) {
        return this.sasReconnaissanceDeFormation.typesDeSources.some((e) => this.getCatalogueCodeById(9817, e) == "f")
      }
      return false
    },

    estFormation() {
      return this.getCatalogueCodeById(9811, this.sasReconnaissanceDeFormation.typeDActivite) == "1"
    },

    estEvenement() {
      return this.getCatalogueCodeById(9811, this.sasReconnaissanceDeFormation.typeDActivite) == "2"
    },

    estComiteScientifique() {
      return this.estOui(this.sasReconnaissanceDeFormation.ateliersApprouvesParUnComiteScientifique)
    },

    nEstPasComiteScientifique() {
      return this.estNon(this.sasReconnaissanceDeFormation.ateliersApprouvesParUnComiteScientifique)
    }
  },

  methods: {
    liveSasReconnaissanceFormation(cle) {
      return { endpoint: "/sas-reconnaissance-formation/", cle: cle, fileId: this.sasReconnaissanceDeFormation.id }
    }
  }
}
</script>

<style>
</style>